import React from "react";
import { Link } from "react-router-dom";
import "./planProductTools.css";

export default function PlanProductClient() {
  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 px-4 py-10">
      <div className="max-w-3xl mx-auto">
        <div className="pp-glass rounded-3xl p-8 border border-slate-800 space-y-4">
          <div className="text-xs text-slate-400 font-semibold">Plan Product</div>
          <h1 className="text-2xl font-bold">Client Workspace</h1>
          <p className="text-slate-300">
            This page is a placeholder. If you want the Client experience to
            launch a specific tool/page, tell me what it should render and I’ll
            wire it up.
          </p>

          <div className="flex flex-wrap gap-3 pt-2">
            <Link
              to="/plan-product/consultant"
              className="px-4 py-2 rounded-xl bg-slate-800 hover:bg-slate-700 border border-slate-700 text-sm font-semibold"
            >
              Go to Consultant
            </Link>
            <Link
              to="/plan-product-home"
              className="px-4 py-2 rounded-xl bg-emerald-600 hover:bg-emerald-500 text-sm font-semibold"
            >
              Back to Selector
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
